import React from 'react'
import { useTranslation } from 'react-i18next';

const ExportData = (props) => {
  const { t } = useTranslation();
  

  const calculateColumnTotal = (data, property) => {
    return parseFloat(data?.reduce((accumulator, current) => parseFloat(accumulator) + parseFloat(current[property] ? current[property] : 0), 0)).toFixed(2)
  }

  return (
    <div className='d-none' style={{ display: 'none' }}>
      <table id="content_table" aria-label="sticky table">
        <thead>
          <tr>
            <td>Nr</td>
            <td style={{ width: '300px' }}>{t('worker.table.employee')}</td>
            <td>{t('salaries.salary')}</td>
            <td>{t('salaries.advance')}</td>
            <td>{t('salaries.extraHours')}</td>
            <td>{t('salaries.extraHoursPay')}</td>
            <td>{t('salaries.contributions')}</td>
            <td>{t('salaries.taxes')}</td>
            <td>{t('salaries.netSalary')}</td>
            <td>{t('salaries.bonuses')}</td>
            <td>{t('salaries.penalties')}</td>
            <td>{t('salaries.total')}</td>
          </tr>
        </thead>
        <tbody>
          {props?.salaries?.map((w, index) => (w.status !== -1 &&
            <tr key={w.id + index}>
              <td>{index + 1}</td>
              <td>{
                (() => {
                  const worker = props?.workers.find((i) => (i?.id ?? i?.Id ?? i?.ID) === w.WorkerId);
                  if (!worker) return '';
                  if (worker.name) return worker.name;
                  return `${worker.FirstName || ''} ${worker.LastName || ''}`.trim();
                })()
              }</td>
              <td>{"€ " + (w.Salary || 0 )}</td>
              <td>{"€ " + (w.Advances || 0)}</td>
              <td>{"€ " + (w.ExtraHours + w.ExtraHoursWeekend + w.ExtraHoursHoliday || 0)}</td>
              <td>{"€ " + (w.HourSalary || 0)}</td>
              <td>{"€ " + (w?.contributions || 0)}</td>
              <td>{"€ " + (w?.taxes || 0)}</td>
              <td>{"€ " + (w?.neto || 0)}</td>
              <td>{"€ " + (w?.Bonus || 0)}</td>
              <td>{"€ " + (w?.Penalties || 0)}</td>
              <td>{"€ " + (w?.total || 0)}</td>
            </tr>
          ))}
          <tr className='d-none1' style={{ fontWeight: 'bold' }}>
            <td></td>
            <td></td>
            <td>{calculateColumnTotal(props?.salaries, 'Salary')}</td>
            <td>{calculateColumnTotal(props?.salaries, 'Advances')}</td>
            <td>
              {
                parseFloat(parseFloat(calculateColumnTotal(props?.salaries, 'ExtraHours')) +
                  parseFloat(calculateColumnTotal(props?.salaries, 'ExtraHoursWeekend')) +
                  parseFloat(calculateColumnTotal(props?.salaries, 'ExtraHoursHoliday'))).toFixed(2)
              }
            </td>
            <td>{calculateColumnTotal(props?.salaries, 'HourSalary')}</td>
            <td>{calculateColumnTotal(props?.salaries, 'contributions')}</td>
            <td>{calculateColumnTotal(props?.salaries, 'taxes')}</td>
            <td>{calculateColumnTotal(props?.salaries, 'neto')}</td>
            <td>{calculateColumnTotal(props?.salaries, 'Bonus')}</td>
            <td>{calculateColumnTotal(props?.salaries, 'Penalties')}</td>
            <td>{calculateColumnTotal(props?.salaries, 'total')}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default ExportData
